export const LOCAL_ID_PREFIX = "local-";

export const MAX_QUESTION_LENGTH = 150;
export const MAX_ANSWER_LENGTH = 600;

export const MAX_FAQS = 30;
